// A conversation becomes read-only when the counterpart can no longer be
// reached. The backend owns the decision and exposes only semantic signals on
// the conversation payload (never raw `blocked`/`deleted_at`):
//   - `lock_reason`: 'deleted' | 'blocked' | null (drives the footer banner).
//   - per-user `is_deleted`: masks the deleted user's name + avatar (STU-29).
export const LOCK_REASON = {
  DELETED: 'deleted',
  BLOCKED: 'blocked',
};

// A user has deleted their account when the backend flags `is_deleted`.
export const isDeletedUser = (user) => Boolean(user && user.is_deleted);

// True when the conversation has at least one other participant to message.
// Guards against sending into a conversation with no reachable counterpart.
export const hasReachableCounterpart = (users, currentUserId) =>
  Array.isArray(users) && users.some((u) => u && u.id !== currentUserId);
